import { render } from "./Plan.vue?vue&type=template&id=89c3009e&scoped=true&ts=true"
import script from "./Plan.vue?vue&type=script&lang=ts"
export * from "./Plan.vue?vue&type=script&lang=ts"

import "./Plan.vue?vue&type=style&index=0&id=89c3009e&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89c3009e"]])

export default __exports__